/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateSigintSensorForm,
  UpdateSigintSensorForm$Outbound,
  UpdateSigintSensorForm$outboundSchema,
} from "../components/updatesigintsensorform.js";

export type UpdateSigintSensorSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpdateSigintSensorSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpdateSigintSensorSecurity = {
  option1?: UpdateSigintSensorSecurityOption1 | undefined;
  option2?: UpdateSigintSensorSecurityOption2 | undefined;
};

export type UpdateSigintSensorRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateSigintSensorForm: UpdateSigintSensorForm;
};

/** @internal */
export type UpdateSigintSensorSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpdateSigintSensorSecurityOption1$outboundSchema: z.ZodMiniType<
  UpdateSigintSensorSecurityOption1$Outbound,
  UpdateSigintSensorSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateSigintSensorSecurityOption1ToJSON(
  updateSigintSensorSecurityOption1: UpdateSigintSensorSecurityOption1,
): string {
  return JSON.stringify(
    UpdateSigintSensorSecurityOption1$outboundSchema.parse(
      updateSigintSensorSecurityOption1,
    ),
  );
}

/** @internal */
export type UpdateSigintSensorSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpdateSigintSensorSecurityOption2$outboundSchema: z.ZodMiniType<
  UpdateSigintSensorSecurityOption2$Outbound,
  UpdateSigintSensorSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function updateSigintSensorSecurityOption2ToJSON(
  updateSigintSensorSecurityOption2: UpdateSigintSensorSecurityOption2,
): string {
  return JSON.stringify(
    UpdateSigintSensorSecurityOption2$outboundSchema.parse(
      updateSigintSensorSecurityOption2,
    ),
  );
}

/** @internal */
export type UpdateSigintSensorSecurity$Outbound = {
  Option1?: UpdateSigintSensorSecurityOption1$Outbound | undefined;
  Option2?: UpdateSigintSensorSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpdateSigintSensorSecurity$outboundSchema: z.ZodMiniType<
  UpdateSigintSensorSecurity$Outbound,
  UpdateSigintSensorSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpdateSigintSensorSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpdateSigintSensorSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function updateSigintSensorSecurityToJSON(
  updateSigintSensorSecurity: UpdateSigintSensorSecurity,
): string {
  return JSON.stringify(
    UpdateSigintSensorSecurity$outboundSchema.parse(updateSigintSensorSecurity),
  );
}

/** @internal */
export type UpdateSigintSensorRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateSigintSensorForm: UpdateSigintSensorForm$Outbound;
};

/** @internal */
export const UpdateSigintSensorRequest$outboundSchema: z.ZodMiniType<
  UpdateSigintSensorRequest$Outbound,
  UpdateSigintSensorRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateSigintSensorForm: UpdateSigintSensorForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      updateSigintSensorForm: "UpdateSigintSensorForm",
    });
  }),
);

export function updateSigintSensorRequestToJSON(
  updateSigintSensorRequest: UpdateSigintSensorRequest,
): string {
  return JSON.stringify(
    UpdateSigintSensorRequest$outboundSchema.parse(updateSigintSensorRequest),
  );
}
